import React from "react";
import Preloader from "./Preloader";
function Pending() {
  return (
    <div className="d-flex flex-column justify-content-center align-items-center mh100">
      <Preloader />
    </div>
  );
}
export default Pending;
